export default [
  {
    description: 'Exportar Arquivo da 2ª Etapa (Situação Final)',
    path: '/censoescolar/situacaofinal',
    name: 'censo_exportar_etapa2',
    component: () => import('@/views/censoescolar/situacaofinal/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Relatório de Pendências da 2ª Etapa (Situação Final)',
    path: '/censoescolar/situacaofinal',
    name: 'censo_rel_pendencias_etapa2',
    component: () => import('@/views/censoescolar/situacaofinal/RelatorioPendencias.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

